import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, SectionFooter, SectionHeader } from './ui';
import PlanCard from './PlanCard';

const StyledFeaturedPlans = styled.section`
  ${sectionPaddings()};
  background-color: ${standardColours.lightGrey};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.large`
    grid-template-columns: repeat(3, 1fr);
  `}
`;

const FeaturedPlans = ({ heading, text, items }) => {
  const { contentfulPlans } = useStaticQuery(graphql`
    query FeaturedPlansQuery {
      contentfulPlans {
        ...LinkFragment
      }
    }
  `);

  return (
    <StyledFeaturedPlans>
      <Container>
        <SectionHeader heading={heading} text={text} />
        <StyledItems>
          {items.map((item, id) => (
            <PlanCard key={id} {...item} />
          ))}
        </StyledItems>
        <SectionFooter
          link={{
            text: 'View all plans',
            pageUrl: contentfulPlans,
          }}
        />
      </Container>
    </StyledFeaturedPlans>
  );
};

export default FeaturedPlans;
